// Helper function to build URL
export const buildApiUrl = (endpoint: string): string | null => {
  if (!endpoint) {
    console.error("Endpoint is required");
    return null;
  }

  const baseUrl =
    process.env.REACT_APP_API_BASE ||
    "http://localhost:8090/api/v1/development";

  if (!baseUrl) {
    return null;
  }

  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
  const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;

  const finalUrl = `${cleanBaseUrl}/${cleanEndpoint}`;

  return finalUrl;
};

export interface MutationConfig {
  onSuccess?: (data: any) => void;
  onError?: (error: unknown) => void;
  onMutate?: (variables: any) => void;
}

// Helper function to set cookies
export const setCookie = (name: string, value: string) => {
  const cookieValue = encodeURIComponent(value);
  // Set cookie to expire in 1 day (60 * 60 * 24 = 86400 seconds)
  document.cookie = `${name}=${cookieValue}; path=/; max-age=86400; SameSite=Strict`;
};

// Helper function to clear cookies
export const clearCookie = (name: string) => {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`;
};
